import { API } from "aws-amplify";
import { API_NAME } from "../common/constants";

/**
 * ユーザー単体取得APIコール
 * @param data
 * @returns
 */
export const getUserId = async (userId: string) => {
  const path = `/users/${encodeURIComponent(userId)}`;
  const params = {};
  let result: any;
  await API.get(API_NAME, path, params)
    .then((response) => {
      result = response;
    })
    .catch((e) => {
      console.error(e);
      result = e.response.data;
    });
  return result;
};
